import * as React from 'react';
import Box from '@mui/joy/Box';
import Typography from "@mui/joy/Typography";
import Stack from "@mui/joy/Stack";
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, {
  accordionSummaryClasses,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { Button } from '@mui/material';
import {Link} from "react-router-dom";
import './styles/Join.css'


const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
      transform: 'rotate(90deg)',
    },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
  ...theme.applyStyles('dark', {
    backgroundColor: 'rgba(255, 255, 255, .05)',
  }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));


const Join = () => {
 const [expanded, setExpanded] = React.useState('');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
    return (
            <Box className="App-header" sx={{backgroundColor: '#006494'}}>
                <Box className='pastor-container' sx={{backgroundColor:'white', padding: 6}}>
                    <Stack direction='row' spacing={4}>
                        <Stack className='elder-container' spacing={2}>
                            <Typography level='h1'>Join Us</Typography>
                            <Typography level='h3'>Sunday Morning Experience</Typography>
                            <Typography level='body-lg'>     
                                Our hope is that you will find NHV a comfortable and friendly place. We want you to feel at ease and be free to learn more about what it means to have a relationship with God. We believe this is the key to everything, including all other relationships. That is why our vision begins with helping people draw closer in their relationship with God. This will influence how they grow stronger in their relationship with each other and how they live louder in their relationship with the world. So we encourage you to come as you are and hang out with us some Sunday morning.
                            </Typography>
                        </Stack>
                    </Stack>

                <Box className='pastor-container' sx={{marginTop: 6}}>
                    <Stack direction='row' spacing={4} sx={{display: {md: 'flex', xs: 'none'}}}>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d837.4761177952921!2d-96.5196937!3d32.9006939!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864ea9dc8024ae1f%3A0xd7bbc9e917ccf7a!2sNew%20Horizon%20Vineyard!5e0!3m2!1sen!2sus!4v1748026039587!5m2!1sen!2sus" className='map' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title='NHV-Map'></iframe>
                        <Stack direction='column' spacing={4} textAlign='center'>
                          <Typography level='h3'>Where we are located</Typography>
                          <Link to='https://www.google.com/maps/dir//New+Horizon+Vineyard+4301+Dalrock+Rd+Rowlett,+TX+75088/@32.900632,-96.5188273,18z/data=!4m8!4m7!1m0!1m5!1m1!1s0x864ea9dc8024ae1f:0xd7bbc9e917ccf7a!2m2!1d-96.5187786!2d32.9007486?entry=ttu&g_ep=EgoyMDI1MDUyMS4wIKXMDSoASAFQAw%3D%3D'>
                            <Button variant="outlined">
                                Get Directions
                            </Button>
                          </Link>
                        </Stack>
                    </Stack>
                    <Stack direction='column' spacing={4} sx={{display: {md: 'none', xs: 'flex'}}}>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d837.4761177952921!2d-96.5196937!3d32.9006939!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864ea9dc8024ae1f%3A0xd7bbc9e917ccf7a!2sNew%20Horizon%20Vineyard!5e0!3m2!1sen!2sus!4v1748026039587!5m2!1sen!2sus" className='smallMap' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title='NHV-Map'></iframe>
                        <Stack direction='column' spacing={4} textAlign='center'>
                          <Typography level='h3'>Where we are located</Typography>
                          <Link to='https://www.google.com/maps/dir//New+Horizon+Vineyard+4301+Dalrock+Rd+Rowlett,+TX+75088/@32.900632,-96.5188273,18z/data=!4m8!4m7!1m0!1m5!1m1!1s0x864ea9dc8024ae1f:0xd7bbc9e917ccf7a!2m2!1d-96.5187786!2d32.9007486?entry=ttu&g_ep=EgoyMDI1MDUyMS4wIKXMDSoASAFQAw%3D%3D'>
                            <Button variant="outlined">
                                Get Directions
                            </Button>
                          </Link>
                        </Stack>
                    </Stack>
                </Box>
            </Box>
                <Box className='pastor-container'>
                    <Stack sx={{width: '70vw'}}>
                        <Typography level='h1' sx={{color: 'white', marginBottom: 1, marginTop: 4}}>FAQ</Typography>
                            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                    <Typography level='title-lg' component="span">What time does service start?</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography level='body-lg'>
                                        Service begins at 10:45 am on Sunday Morning
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                                <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                                    <Typography level='title-lg' component="span">What should I wear?</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography level='body-lg'>
                                        At New Horizon Vineyard, it’s all about real people and real connection. just come as you are, no dress code here.
                                    </Typography>
                                    </AccordionDetails>
                            </Accordion>
                            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                                <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                                    <Typography level='title-lg' component="span">Is there Childcare?</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography level='body-lg'>
                                        We have something for the entire family on Sunday morning! Everyone will worship together in the main sanctuary and after worship the children will be released to the childrens ministry where there will be age-appropriate Bible stories, activities, and discussion.  
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                                <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                                    <Typography level='title-lg' component="span">How do I connect online?</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography level='body-lg'>
                                        For the Sunday service you can connect via our <a className='faqLink' href='https://www.youtube.com/@newhorizonvineyardchurch4635' target='_blank' rel="noopener noreferrer">YouTube channel</a>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                    </Stack>
                </Box> 
                </Box>
    );
};

export default Join;